module.exports = __webpack_public_path__ + "img/ieq-logo-white.7f35f6a5.png";